const CONSENT_KEY = "eg-eletrica-consent-v1";
const GA4_ID = import.meta.env.VITE_GA4_MEASUREMENT_ID as string | undefined;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export type ConsentStatus = "granted" | "denied";

export function getConsent(): ConsentStatus | null {
  if (typeof window === "undefined") return null;
  const value = localStorage.getItem(CONSENT_KEY);
  return value === "granted" || value === "denied" ? value : null;
}

export function setConsent(value: ConsentStatus): void {
  localStorage.setItem(CONSENT_KEY, value);
  if (value === "granted") loadGA4();
}

let ga4Loaded = false;

export function loadGA4(): void {
  if (ga4Loaded || !GA4_ID || typeof document === "undefined") return;
  ga4Loaded = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer!.push(args);
  };
  window.gtag("js", new Date());
  // Enviamos o page_view manualmente a cada navegação (ver
  // trackPageView), já que o app é uma SPA — desligamos o automático.
  window.gtag("config", GA4_ID, { send_page_view: false });
}

export function trackPageView(path: string): void {
  if (!ga4Loaded || !window.gtag) return;
  window.gtag("event", "page_view", { page_path: path });
}

export function isAnalyticsConfigured(): boolean {
  return !!GA4_ID;
}
